/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'


export default (props) => {
  const { as = 'i', name, fill, className, ratio = 1, style = {}, onClick, none, disabled } = props
  let f = false
  if (fill) {
    f = true
  }
  const sprededProps = { ...props }
  delete sprededProps.fill
  delete sprededProps.none
  if (props.as === 'a') {
    style.textDecoration = 'none'
    style.color = 'inherit'
  }
  return React.createElement(
    as,
    {
      ...sprededProps,
      onClick: disabled ? undefined : onClick,
      className: `ri-${name}${none ? '' : (f ? '-fill' : '-line')}${className ? ` ${className}` : ''}`,
      style: {
        fontSize: 20 * ratio,
        ...style,
        cursor: onClick && !disabled ? 'pointer' : null,
      },
    },
  )
}
